export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20cinematic%20stage%20with%20warm%20spotlight%20illumination%2C%20deep%20crimson%20and%20amber%20color%20gradients%2C%20abstract%20geometric%20composition%2C%20mysterious%20atmosphere%20with%20floating%20dust%20particles%2C%20theatrical%20curtain%20silhouette%2C%20editorial%20photography%20style%20with%20high%20contrast%2C%20texture-rich%20background&width=1600&height=900&seq=hero-bg-2026-x1&orientation=landscape"
          alt="黑料吃瓜爆料网 - 首页主视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-500/90 text-background-50 text-xs font-medium px-3 py-1.5 rounded-full mb-5">
              <i className="ri-fire-fill text-sm"></i>
              <span>今日更新 2,847 条</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight">
              黑料吃瓜爆料
              <br />
              <span className="text-accent-300">全网黑料一站式搜索平台</span>
            </h1>

            <p className="text-accent-200 text-base md:text-lg mt-3 font-heading">
              搜你想搜，看你所看——吃瓜群众的终极武器
            </p>

            <p className="mt-6 text-background-50/80 text-sm md:text-base leading-relaxed max-w-xl lg:max-w-none">
              黑料吃瓜爆料网汇聚全网最新最全的明星八卦、网络爆料和娱乐资讯。覆盖微博、抖音、小红书等主流平台实时热点，
              提供精准的黑料查询和吃瓜搜索服务。每天更新数千条独家爆料，让你不再错过任何一个精彩瞬间。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mt-7">
              <div className="flex items-center gap-2 text-background-50/70 text-xs">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span>覆盖 50+ 平台实时监控</span>
              </div>
              <div className="flex items-center gap-2 text-background-50/70 text-xs">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span>日更新量 3,000+ 条</span>
              </div>
              <div className="flex items-center gap-2 text-background-50/70 text-xs">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span>7×24 小时不间断追踪</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#updates"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 text-background-50 px-7 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                立即浏览最新快讯
              </a>
              <a
                href="#topics"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-background-50/15 text-background-50 border border-background-50/30 px-7 py-3 rounded-full text-sm font-medium hover:bg-background-50/25 transition-colors cursor-pointer"
              >
                <i className="ri-hashtag"></i>
                探索话题热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[360px] md:w-[360px] md:h-[460px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20scene%20with%20warm%20crimson%20and%20amber%20lighting%2C%20mysterious%20silhouette%20of%20a%20person%20holding%20a%20magnifying%20glass%20over%20floating%20newspaper%20clippings%2C%20detective-themed%20gossip%20investigation%20vibe%2C%20texture-rich%20dark%20background%20with%20glowing%20highlights%2C%20editorial%20photography%20style%2C%20dramatic%20shadows%2C%20warm%20tone&width=800&height=1000&seq=hero-visual-main-01&orientation=portrait"
                alt="黑料吃瓜爆料 - 全网搜索与爆料"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}